import React, { useEffect, useRef, useState } from "react";
import dataService from "../networks/api/service/dataService";
import {
  Button,
  Input,
  message,
  Select,
  Table,
  Modal,
  Form,
  Popconfirm,
  Switch,
  Radio,
} from "antd";
import FullScreenLoader from "../components/FullScreenLoader";
import VoterPieChart from "../components/VoterPieChart";
import CustomTable from "../components/TableComponent/CustomTable";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
import "./VoterList.css";
import { PieChartData } from "../assets/data/PieChartData";
import { width } from "@mui/system";
const { Option } = Select;

function VotersList() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [assemblyList, setassemblyList] = useState([]);
  const [panchayatList, setpanchayatList] = useState([]);
  const [booth, setbooth] = useState([]);
  const [assemblyId, setassemblyId] = useState("");
  const [panchayatId, setpanchayatId] = useState("");
  const [boothId, setboothId] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentVoter, setCurrentVoter] = useState(null);
  const [constituencyList, setconstituencyList] = useState([]);
  const [constituencyId, setconstituencyId] = useState("");
  const [loading, setloading] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [genderData, setGenderData] = useState([]);
  const [ageData, setAgeData] = useState([]);
  const [totalVoters, setTotalVoters] = useState(0);
  const [skip, setskip] = useState(0);
  const [limit, setlimit] = useState(10);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [form] = Form.useForm();
  const targetDivRef = useRef(null);

  useEffect(() => {
    getAllVoters();
    getConstituency();
  }, []);

  const handleTableChange = (pagination) => {
    const current = pagination.current; // Current page
    const pageSize = pagination.pageSize; // Page size
    const skip = (current - 1) * pageSize; // Calculate skip
    const limit = pageSize; // Limit is the same as page size

    setPagination(pagination);
    setskip(skip);
    setlimit(limit);
  };

  const getAllVoters = async () => {
    try {
      setloading(true);
      const res = await dataService.getAllVoters();
      if (res.code === 200) {
        setData(res?.data);
        setFilteredData(res?.data);
      }
      setloading(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) {
        setconstituencyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (constituencyId && assemblyId && boothId && panchayatId) {
      getTableData();
    }
  }, [constituencyId, assemblyId, boothId, panchayatId]);

  const OnAssemblySelect = async (value) => {
    setassemblyId(value);
    setpanchayatId("");
    setboothId("");
    setbooth([]);
    setpanchayatList([]);
    const data = { assembly: value };
    try {
      const res = await dataService.getPanchayatFromAssembly(data);
      if (res.code === 200) {
        setpanchayatList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnPanchayatSelect = async (value) => {
    setpanchayatId(value);
    setboothId("");
    setbooth([]);
    const data = { panchayat: value };
    try {
      const res = await dataService.GetBooth(data);
      if (res.code === 200) {
        setbooth(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnBoothSelect = (value) => {
    setboothId(value);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setskip(0);
    setlimit(10);
  };

  const OnConstituencySelect = async (value) => {
    console.log(value, "vaues");
    setconstituencyId(value);
    setassemblyId("");
    setpanchayatId("");
    setboothId("");
    setassemblyList([]);
    setbooth([]);
    setpanchayatList([]);
    try {
      const res = await dataService.getAssemblyFromConstituency(value);
      if (res.code === 200) {
        setassemblyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getVotersList = async () => {
    const data = { _id: boothId };

    try {
      const res = await dataService.GetVoters(
        data,
        boothId,
        skip,
        limit,
        "booth"
      );
      if (res.code === 200) {
        setData(res?.data);
        setFilteredData(res?.data);

        setPagination((prev) => ({
          ...prev,
          total: res?.totalVoters,
        }));
      }
    } catch (e) { }
  };

  const getTableData = () => {
    if (panchayatId && assemblyId && boothId) {
      getVotersList();
    } else {
      message.warning("Select Panchayat, Assembly, and Booth.");
    }
  };

  useEffect(() => {
    if (panchayatId && assemblyId && boothId) {
      getVotersList();
    }
  }, [skip, limit]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data?.filter(
      (item) =>
        item?.firstName?.toLowerCase()?.includes(value) ||
        item?.epicNo?.toLowerCase()?.includes(value)
    );
    setFilteredData(filtered);
  };

  const handleEdit = (voter) => {
    setCurrentVoter(voter);
    form.setFieldsValue(voter);
    setIsModalVisible(true);
  };

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Handles deletion of a voter by calling the deleteVoter service
   * and updates the voter list by calling getAllVoters.
   * @param {string} voterId - The id of the voter to be deleted.
   */
  /******  3efd9558-70af-4674-a158-c5743c1bc63c  *******/
  const handleDelete = async (voterId) => {
    try {
      await dataService.deleteVoter(voterId); // Adjust with your delete service
      message.success("Voter deleted successfully.");
      getAllVoters();
    } catch (e) {
      console.error(e);
      message.error("Failed to delete voter.");
    }
  };

  const editTableData = async (id, payload) => {
    try {
      const res = await dataService.editVoter(id, payload);
      console.log(res);
      if (res.code === 200) {
        message.success("voter updated successfully");
        getAllVoters();
      }
    } catch (e) { }
  };

  const handleModalOk = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values, "vall");
        const payload = { ...currentVoter, ...values };
        // Here you could send the updated data to the server
        editTableData(currentVoter.epicNo, payload);
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.error("Validate Failed:", info);
      });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleInfluencerToggle = async (checked, voter) => {
    console.log(voter);
    setloading(true);
    const data = {
      influencer: checked,
    };
    try {
      const res = await dataService.addInfluencer(voter._id, data);
      if (res.code == 200) {
        if (panchayatId && assemblyId && boothId) {
          getVotersList();
        } else {
          getAllVoters();
        }
      }
    } catch (e) { }
    // Perform any necessary actions, e.g., updating backend or state
    setTimeout(() => {
      setloading(false);
    }, 300);
  };

  const handleFamilyHeadToggle = async (checked, voter) => {
    console.log(voter);
    setloading(true);
    const data = {
      familyHead: checked,
    };
    try {
      const res = await dataService.familyHead(voter._id, data);
      if (res.code == 200) {
        if (panchayatId && assemblyId && boothId) {
          getVotersList();
        } else {
          getAllVoters();
        }
      }
    } catch (e) { }
    // Perform any necessary actions, e.g., updating backend or state
    setTimeout(() => {
      setloading(false);
    }, 300);
  };

  const handleNewVoterToggle = async (checked, voter) => {
    console.log(voter);
    setloading(true);
    const data = {
      newVoter: checked,
    };
    try {
      const res = await dataService.NewVoter(voter._id, data);
      if (res.code === 200) {
        if (panchayatId && assemblyId && boothId) {
          getVotersList();
        } else {
          getAllVoters();
        }
      }
    } catch (e) {
      console.error("Error updating New Voter status:", e);
    }
    // Perform any necessary actions, e.g., updating backend or state
    setTimeout(() => {
      setloading(false);
    }, 300);
  };

  const getPieData = (value) => {
    console.log(value, "d");
    let maleCount = 0;
    let femaleCount = 0;

    // Age Group Distribution Calculation
    let age18_25 = 0;
    let age25_35 = 0;
    let age35_45 = 0;
    let age45_55 = 0;
    let ageAbove55 = 0;

    value?.forEach((voter) => {
      // Gender calculation
      if (voter.gender === "M") maleCount++;
      else if (voter.gender === "F") femaleCount++;

      // Age group calculation
      if (voter.age >= 18 && voter.age <= 25) age18_25++;
      else if (voter.age > 25 && voter.age <= 35) age25_35++;
      else if (voter.age > 35 && voter.age <= 45) age35_45++;
      else if (voter.age > 45 && voter.age <= 55) age45_55++;
      else if (voter.age > 55) ageAbove55++;
    });

    const totalGender = maleCount + femaleCount;
    const totalAgeGroups =
      age18_25 + age25_35 + age35_45 + age45_55 + ageAbove55;

    const genderData = [
      { name: "Male", value: (maleCount / totalGender) * 100 },
      { name: "Female", value: (femaleCount / totalGender) * 100 },
    ];

    // Set Age Data (keep values as numbers)
    const ageData = [
      { name: "18-25", value: (age18_25 / totalAgeGroups) * 100 },
      { name: "25-35", value: (age25_35 / totalAgeGroups) * 100 },
      { name: "35-45", value: (age35_45 / totalAgeGroups) * 100 },
      { name: "45-55", value: (age45_55 / totalAgeGroups) * 100 },
      { name: "55+", value: (ageAbove55 / totalAgeGroups) * 100 },
    ];

    console.log(
      genderData,
      ageData,
      totalGender,
      "genderData, ageData, totalVoters"
    );
    setGenderData(genderData);
    setAgeData(ageData);
    setTotalVoters(totalGender);

    setTimeout(() => {
      if (targetDivRef.current) {
        targetDivRef.current.scrollIntoView({
          behavior: "smooth", // Smooth scrolling
          block: "start", // Scroll to the top of the element
        });
      }
    }, 1000);
  };

  // const getPieData = (value) => {
  //   const data = PieChartData(value);
  //   console.log(data, "data");
  //   if (data) {
  //     setGenderData([...data.genderData]);
  //     setAgeData([...data.ageData]);
  //     setTotalVoters(data.totalGender);
  //   } else {
  //     alert("No data found");
  //   }
  // };

  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      align: "center",
      width: 150,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      align: "center",
      width: 150,
    },
    {
      title: "Booth Number",
      dataIndex: "boothNumber",
      key: "boothNumber",
      width: 150,
      align: "center",
    },
    {
      title: "Section Number",
      dataIndex: "sectionNumber",
      key: "sectionNumber",
      width: 150,
      align: "center",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      width: 100,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      align: "center",
    },
    {
      title: "Relation Type",
      dataIndex: "relationType",
      key: "relationType",
      width: 150,
      align: "center",
    },
    {
      title: "Relation Name",
      render: (text, voter) => (
        <span>
          {voter.relationFirstName} {voter.relationLastName}
        </span>
      ),
      key: "relationName",
      align: "center",
      width: 150,
    },
    {
      title: "EPIC No",
      dataIndex: "epicNo",
      key: "epicNo",
      align: "center",
      width: 130,
    },
    {
      title: "Stay Outside",
      render: (text, voter) => {
        return <span>{voter.stayOutSide ? "Yes" : "No"}</span>;
      },
      key: "stayOutSide",
      width: 120,
      align: "center",
    },
    {
      title: (
        <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          Relation With <br /> Sangha Pariwar
        </div>
      ),
      render: (text, voter) => {
        return <span>{voter.relationWithSanghaPariwar ? "Yes" : "No"}</span>;
      },
      key: "relationWithSanghaPariwar",
      width: 190, // Reduced width
      align: "center",
    },

    {
      title: "Influencer",
      key: "influencer",
      align: "center",
      width: 110,

      render: (text, voter) => (
        <Switch
          checked={voter.influencer}
          onChange={(checked) => handleInfluencerToggle(checked, voter)}
        />
      ),
    },
    {
      title: "Head Of Family",
      key: "headOfFamily",
      align: "center",
      width: 150,

      render: (text, voter) => (
        <Switch
          checked={voter.headOfFamily}
          onChange={(checked) => handleFamilyHeadToggle(checked, voter)}
        />
      ),
    },
    {
      title: "New Voter",
      key: "newVoter",
      align: "center",
      width: 100,
      render: (text, voter) => (
        <Switch
          checked={voter.newVoter}
          onChange={(checked) => handleNewVoterToggle(checked, voter)}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",

      render: (text, voter) => (
        <div>
          <Button type="link" onClick={() => handleEdit(voter)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this voter?"
            onConfirm={() => handleDelete(voter._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* {loading && <FullScreenLoader />} */}

      <h2>Voters List</h2>

      <div
        style={{
          marginBottom: 20,
          display: "flex",
          flexWrap: "wrap", // Allow wrapping on smaller screens
          justifyContent: "space-between",
          gap: "10px", // Add space between items for better readability
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap", // Enable wrapping inside this container
            justifyContent: "center",
            alignItems: "center",
            gap: "10px", // Add consistent spacing
          }}
        >
          <Select
            value={constituencyId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const children = option?.children;
              return String(children)
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            placeholder="Select Parliament"
            style={{ minWidth: 150, border: "1px solid grey", borderRadius: 5 }}
            onChange={(value) => OnConstituencySelect(value)}
          >
            <Option key={827272} value="" disabled>
              Select Parliament
            </Option>
            {constituencyList?.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.constituencyName}
              </Option>
            ))}
          </Select>

          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const children = option?.children;
              return String(children)
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            placeholder="Select Assembly"
            style={{ minWidth: 150, border: "1px solid grey", borderRadius: 5 }}
            onChange={OnAssemblySelect}
            value={assemblyId}
          >
            <Option key={827272} value="" disabled>
              Select Assembly
            </Option>
            {assemblyList?.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.assemblyName}
              </Option>
            ))}
          </Select>

          <Select
            value={panchayatId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const children = option?.children;
              return String(children)
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            placeholder="Select Panchayat"
            style={{ minWidth: 150, border: "1px solid grey", borderRadius: 5 }}
            onChange={OnPanchayatSelect}
          >
            <Option key={827272} value="" disabled>
              Select Panchayat
            </Option>
            {panchayatList?.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.panchayatName}
              </Option>
            ))}
          </Select>

          <Select
            value={boothId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              const children = option?.children;
              return String(children)
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            placeholder="Select Booth"
            style={{ minWidth: 150, border: "1px solid grey", borderRadius: 5 }}
            onChange={OnBoothSelect}
          >
            <Option key={827272} value="" disabled>
              Select Booth
            </Option>
            {booth?.map((item) => (
              <Option key={item?._id} value={item?._id}>
                {item?.boothNumber}
              </Option>
            ))}
          </Select>
          {/* <PrimaryButton
            type="primary"
            onClick={getTableData}
            style={{ marginLeft: "30px", minWidth: "80px" }}
          >
            Enter
          </PrimaryButton> */}
          {/* {filteredData?.length > 0 && (
            <PrimaryButton
              type="primary"
              style={{ marginLeft: "30px", minWidth: "80px" }}
              onClick={() => {
                getPieData(filteredData);
              }}
            >
              PieChart
            </PrimaryButton>
          )} */}
        </div>

        <Input.Search
          placeholder="Search by Voter Name"
          onChange={handleSearch}
          style={{ width: "100%", maxWidth: 200 }} // Full width on small screens
        />
      </div>

      <CustomTable
        dataSource={filteredData}
        columns={columns}
        rowKey={(record) => record._id}
        loading={loading}
        bordered
        onChange={handleTableChange}
        customPagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20"],
        }}
        size="middle"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
        scroll={{ x: 800 }}
        rowClassName={(record) =>
          record.headOfFamily ? "head-of-family-row" : ""
        } // Conditionally apply class
      />

      {totalVoters > 0 && (
        <div ref={targetDivRef}>
          <VoterPieChart
            genderData={genderData}
            totalVotersList={totalVoters}
            chartData={chartData}
            ageData={ageData}
          />
        </div>
      )}

      <Modal
        title="Edit Voter"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="boothName" label="Booth Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="sectionName" label="Section Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="boothNumber" label="Booth Number"
            rules={[
              { pattern: /^[0-9]+$/, message: "Only numbers are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="sectionNumber" label="Section Number"
            rules={[
              { pattern: /^[0-9]+$/, message: "Only numbers are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="houseNumber" label="House Number"
            rules={[
              { pattern: /^[0-9]+$/, message: "Only numbers are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="familyCode" label="Family Code">
            <Input />
          </Form.Item>
          <Form.Item name="firstName" label="First Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="lastName" label="Last Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>

            <Input />
          </Form.Item>
          <Form.Item name="relationType" label="Relation Type"
          rules={[
            { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
          ]}>
            <Input />
          </Form.Item>
          <Form.Item name="relationFirstName" label="Relation First Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="relationLastName" label="Relation Last Name"
            rules={[
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="gender" label="Gender">
            <Select placeholder="Select gender">
              <Select.Option value="male">Male</Select.Option>
              <Select.Option value="female">Female</Select.Option>
              <Select.Option value="other">Other</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="age" label="Age"
            rules={[
              { pattern: /^[0-9]+$/, message: "Only numbers are allowed" }
            ]}>
            <Input />
          </Form.Item>
          <Form.Item name="dob" label="Date of Birth">
            <Input type="date" />
          </Form.Item>
          <Form.Item
            name="stayOutSide"
            label="Stay Outside"
            valuePropName="checked"
          >
            <Switch checkedChildren="Yes" unCheckedChildren="No" />
          </Form.Item>
          <Form.Item
            name="relationWithSanghaPariwar"
            label="Relation With Sangha Pariwar"
            valuePropName="checked"
          >
            <Switch checkedChildren="Yes" unCheckedChildren="No" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default VotersList;
